import Cookies from 'js-cookie';
import { EXPIRATION_TOKEN_KEY } from '../constants/constants';
import { logger } from './Log';
export var expiredSession = function () {
    var expirationDate = Cookies.get(EXPIRATION_TOKEN_KEY);
    if (!expirationDate) {
        //If there is not an expiration date for the current session, we return false to avoid issues with B2B (we don´t have the login callback in B2B for now).
        //The properly expiration date will be set in the check session when CentralProvider is rendered
        //TODO remove it when adding the cookie from launchpad or when adding the callback from B2B
        return false;
    }
    if (parseInt(expirationDate) < Math.floor(Date.now() / 1000)) {
        logger('session expired', expirationDate);
        return true;
    }
    return false;
};
//# sourceMappingURL=expiredSession.js.map